import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const ifAuthenticated = async (to, from, next) => {
  document.title = `${to.meta.name + (to.meta.name.length ? ' - ' : '')}СК Грань`;
  next();
};

const router = new VueRouter({
  mode: 'history',
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Home',
      component: () => import('../pages/Home.vue'),
      meta: {
        name: 'Главная',
        breadcrumbs: [],
      },
    },

    {
      path: '/news',
      name: 'News',
      component: () => import('../pages/News/index.vue'),
      meta: {
        name: 'Новости',
        breadcrumbs: [{ to: '/', name: 'Главная' }],
      },
    },
    {
      path: '/news/:id',
      name: 'NewsID',
      component: () => import('../pages/News/id.vue'),
      meta: {
        name: 'Новости',
        breadcrumbs: [
          { to: '/', name: 'Главная' },
          { to: '/news', name: 'Новости' },
        ],
      },
    },

    {
      path: '/photos',
      name: 'Photos',
      component: () => import('../pages/Photos/index.vue'),
      meta: {
        name: 'Фотоархив',
        breadcrumbs: [{ to: '/', name: 'Главная' }],
      },
    },
    {
      path: '/photos/:id',
      name: 'PhotosID',
      component: () => import('../pages/Photos/id.vue'),
      meta: {
        name: 'Фотоархив',
        breadcrumbs: [
          { to: '/', name: 'Главная' },
          { to: '/photos', name: 'Фотоархив' },
        ],
      },
    },
    {
      path: '/videos',
      name: 'Videos',
      component: () => import('../pages/Videos/index.vue'),
      meta: {
        name: 'Видеоархив',
        breadcrumbs: [{ to: '/', name: 'Главная' }],
      },
    },

    {
      path: '/achievements',
      name: 'Achievements',
      component: () => import('../pages/Achievements/index.vue'),
      meta: {
        name: 'Награды',
        breadcrumbs: [{ to: '/', name: 'Главная' }],
      },
    },

    {
      path: '/documents',
      name: 'Documents',
      component: () => import('../pages/Documents/index.vue'),
      meta: {
        name: 'Документы',
        breadcrumbs: [{ to: '/', name: 'Главная' }],
      },
    },

    {
      path: '/directorship',
      name: 'Directorship',
      component: () => import('../pages/Directorship/index.vue'),
      meta: {
        name: 'Руководство',
        breadcrumbs: [
          { to: '/', name: 'Главная' },
          { to: '/directorship', name: 'Руководство' },
        ],
      },
    },

    {
      path: '/tenders',
      name: 'Tenders',
      component: () => import('../pages/Tenders/index.vue'),
      meta: {
        name: 'Тендеры',
        breadcrumbs: [{ to: '/', name: 'Главная' }],
      },
    },

    {
      path: '/projects',
      name: 'Projects',
      component: () => import('../pages/Projects/index.vue'),
      meta: {
        name: 'Портфель проектов',
        breadcrumbs: [{ to: '/', name: 'Главная' }],
      },
    },
    {
      path: '/projects/:id',
      name: 'ProjectsID',
      component: () => import('../pages/Projects/id.vue'),
      meta: {
        name: 'Портфель проектов',
        breadcrumbs: [
          { to: '/', name: 'Главная' },
          { to: '/projects', name: 'Портфель проектов' },
        ],
      },
    },

    {
      path: '/career',
      name: 'Career',
      component: () => import('../pages/Career/index.vue'),
      meta: {
        name: 'Карьера',
        breadcrumbs: [{ to: '/', name: 'Главная' }],
      },
    },

    {
      path: '/investor',
      name: 'Investor',
      component: () => import('../pages/Investor/index.vue'),
      meta: {
        name: 'Инвесторам',
        breadcrumbs: [{ to: '/', name: 'Главная' }],
      },
    },

    {
      path: '/customer',
      name: 'Customer',
      component: () => import('../pages/Customer/index.vue'),
      meta: {
        name: 'Заказчикам',
        breadcrumbs: [{ to: '/', name: 'Главная' }],
      },
    },
    {
      path: '/estate',
      name: 'Estate',
      component: () => import('../pages/Estate/index.vue'),
      meta: {
        name: 'Продажа недвижимости',
        breadcrumbs: [{ to: '/', name: 'Главная' }],
      },
    },
    {
      path: '/contacts',
      name: 'Contacts',
      component: () => import('../pages/Contacts/index.vue'),
      meta: {
        name: 'Контакты',
        breadcrumbs: [{ to: '/', name: 'Главная' }],
      },
    },
    {
      path: '/contractor',
      name: 'Contractor',
      component: () => import('../pages/Contractor/index.vue'),
      meta: {
        name: 'Подрядчикам',
        breadcrumbs: [{ to: '/', name: 'Главная' }],
      },
    },

    {
      path: '/sout',
      name: 'JSHA',
      component: () => import('../pages/JSHA/index.vue'),
      meta: {
        name: 'СОУТ',
        breadcrumbs: [{ to: '/', name: 'Главная' }],
      },
    },

    {
      path: '*',
      redirect: '/',
    },
  ],
});

router.beforeEach(ifAuthenticated);

export default router;
